var map = {
	"./Montserrat-Medium.ttf": "./assets/resource/fonts/Montserrat-Medium.ttf",
	"./Montserrat-Regular.ttf": "./assets/resource/fonts/Montserrat-Regular.ttf",
	"./Montserrat-SemiBold.ttf": "./assets/resource/fonts/Montserrat-SemiBold.ttf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./assets/resource/fonts sync recursive \\.(woff%7Cwoff2%7Ceot%7Cttf%7Cotf)$";